module.exports = __webpack_public_path__ + "static/media/lanchonete.c1629348.svg";